/* TREUDAS — session & UTM tracking per tema Shopify
 *
 * Catturato all'arrivo (advertorial o product page) e propagato all'ordine Shopify
 * tramite:
 *  - line item properties (POST /cart/add) → visibili nel singolo prodotto dell'ordine
 *  - cart attributes (POST /cart/update.js)  → visibili nelle "Note ordine"
 *
 * Il Meta Pixel (PageView/ViewContent/AddToCart/InitiateCheckout/Purchase) è già
 * gestito dal Custom Pixel "Treudas Meta Pixel" lato Shopify — qui non si tocca.
 */
(function () {
  'use strict';

  const STORAGE_KEY = 'treudas_session_v1';
  const TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 giorni
  const UTM_KEYS = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','fbclid','gclid','ttclid'];

  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  function eventId() {
    return 'tr_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8);
  }

  function readQuery() {
    const out = {};
    const q = new URLSearchParams(window.location.search);
    UTM_KEYS.forEach(k => { const v = q.get(k); if (v) out[k] = v; });
    return out;
  }

  function load() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const d = JSON.parse(raw);
      if (!d || !d.id || !d.created_at) return null;
      if (Date.now() - d.created_at > TTL_MS) return null;
      return d;
    } catch (e) { return null; }
  }

  function save(s) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(s)); } catch (e) {}
  }

  function init() {
    let s = load();
    const fresh = readQuery();
    const now = Date.now();

    if (!s) {
      s = {
        id: uuid(),
        created_at: now,
        landing_page: window.location.pathname + window.location.search,
        referrer: document.referrer || '',
        utm: fresh,
        page_views: 0
      };
    } else if (Object.keys(fresh).length > 0) {
      // se l'utente torna con nuovi UTM, aggiornali ma mantieni session id
      s.utm = Object.assign({}, s.utm, fresh);
    }

    s.page_views = (s.page_views || 0) + 1;
    s.last_seen_at = now;
    s.last_page = window.location.pathname;
    save(s);
    return s;
  }

  const session = init();

  // ─────────────────────────────────────────────────────────────────────
  // Propaga la sessione a Shopify quando si invia il form ATC
  // ─────────────────────────────────────────────────────────────────────
  function injectIntoCartForm() {
    const form = document.getElementById('treudas-form');
    if (!form) return;

    form.addEventListener('submit', function () {
      const s = load() || session;
      const fbAtcEventId = eventId();
      const fbIcoEventId = eventId();

      const props = {
        'properties[_session_id]':   s.id,
        'properties[_landing_page]': s.landing_page,
        'properties[_referrer]':     s.referrer,
        'properties[_utm_source]':   (s.utm && s.utm.utm_source)   || '',
        'properties[_utm_medium]':   (s.utm && s.utm.utm_medium)   || '',
        'properties[_utm_campaign]': (s.utm && s.utm.utm_campaign) || '',
        'properties[_utm_content]':  (s.utm && s.utm.utm_content)  || '',
        'properties[_utm_term]':     (s.utm && s.utm.utm_term)     || '',
        'properties[_fbclid]':       (s.utm && s.utm.fbclid)       || '',
        'properties[_gclid]':        (s.utm && s.utm.gclid)        || '',
        'properties[_ttclid]':       (s.utm && s.utm.ttclid)       || '',
        'properties[_fb_atc_event_id]': fbAtcEventId,
        'properties[_fb_ico_event_id]': fbIcoEventId
      };

      Object.keys(props).forEach(function (name) {
        if (!props[name]) return;
        // evita duplicati se esiste già un hidden con lo stesso name
        if (form.querySelector('input[name="' + name + '"]')) return;
        const i = document.createElement('input');
        i.type = 'hidden';
        i.name = name;
        i.value = props[name];
        form.appendChild(i);
      });
    });

    // In parallelo: scrivi gli stessi dati come cart attributes (note ordine)
    // così appaiono anche fuori dalla scheda prodotto
    try {
      const s = load() || session;
      const body = new URLSearchParams();
      body.set('attributes[session_id]',   s.id);
      body.set('attributes[landing_page]', s.landing_page);
      body.set('attributes[referrer]',     s.referrer);
      if (s.utm) Object.keys(s.utm).forEach(k => body.set('attributes[' + k + ']', s.utm[k]));
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
        body: body.toString(),
        credentials: 'same-origin'
      }).catch(function () {});
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectIntoCartForm);
  } else {
    injectIntoCartForm();
  }

  // API debug
  window.TreudasSession = { get: load, refresh: init };
})();
